import type { MissingItem } from '@qlk/shared';
import { MISSING_ITEM_LABEL } from '@qlk/shared';
import { useState } from 'react';

import { HopThoai, Nut, OChon, StatusBadge } from '../../../ui/index.js';
import { useTaoPost, useTheSanSang } from '../api.js';
import { khoaNgayVn } from './gioThiTruong.js';

export interface DialogLenLichProps {
  onDong: () => void;
  /** Ngày gợi ý sẵn (YYYY-MM-DD, giờ Việt Nam). */
  ngayGoiY?: string;
}

export function DialogLenLich({ onDong, ngayGoiY }: DialogLenLichProps) {
  const sanSang = useTheSanSang();
  const tao = useTaoPost();

  const [itemId, setItemId] = useState('');
  const [ngay, setNgay] = useState(ngayGoiY ?? khoaNgayVn(new Date()));
  const [gio, setGio] = useState('19:00');

  const the = sanSang.data ?? [];
  const dangChon = the.find((t) => t.productionItemId === itemId) ?? the[0];
  const hopLe = Boolean(dangChon) && ngay !== '' && gio !== '';

  function gui() {
    if (!dangChon) return;
    tao.mutate(
      {
        productionItemId: dangChon.productionItemId,
        // Giờ nhập theo GMT+7, gửi lên dưới dạng UTC.
        publishAt: new Date(`${ngay}T${gio}:00+07:00`).toISOString(),
      },
      { onSuccess: onDong },
    );
  }

  return (
    <HopThoai
      title="Lên lịch đăng"
      rong="sm"
      onDong={onDong}
      chanHop={
        <>
          {tao.isError && (
            <p role="alert" className="mr-auto self-center text-phu text-bad-chu">
              {tao.error.message}
            </p>
          )}
          <Nut kieu="phu" onClick={onDong}>
            Huỷ
          </Nut>
          <Nut kieu="chinh" disabled={!hopLe} dangChay={tao.isPending} onClick={gui}>
            Lên lịch
          </Nut>
        </>
      }
    >
      <p className="mt-1 text-phu text-chu-mo">
        Chỉ thẻ từ bước Kiểm duyệt trở đi mới lên lịch được. Giờ nhập theo GMT+7.
      </p>

      {sanSang.isPending && <p className="mt-4 text-co-ban text-chu-phu">Đang tải…</p>}

      {sanSang.data && the.length === 0 && (
        <p className="mt-4 text-co-ban text-chu-phu">
          Chưa có thẻ nào sẵn sàng. Hãy đưa thẻ sang bước Kiểm duyệt ở trang Sản xuất nội dung.
        </p>
      )}

      {the.length > 0 && (
        <div className="mt-4 space-y-4">
          <OChon
            hienNhan
            label="Video"
            value={dangChon?.productionItemId ?? ''}
            onChange={setItemId}
            options={the.map((t) => ({
              value: t.productionItemId,
              label: `${t.channelName} — ${t.title}`,
            }))}
            className="w-full"
          />

          {dangChon && dangChon.missing.length > 0 && (
            <div className="flex flex-wrap gap-1.5">
              {dangChon.missing.map((m: MissingItem) => (
                <StatusBadge key={m} tone="warn">
                  {MISSING_ITEM_LABEL[m]}
                </StatusBadge>
              ))}
            </div>
          )}

          <div className="flex gap-3">
            <div className="flex-1">
              <label htmlFor="ngay-dang" className="mb-1 block text-phu font-medium text-chu-phu">
                Ngày
              </label>
              <input
                id="ngay-dang"
                type="date"
                value={ngay}
                onChange={(e) => {
                  setNgay(e.target.value);
                }}
                className="vung-bam w-full rounded-[10px] border border-vien px-3 text-co-ban text-chu"
              />
            </div>
            <div>
              <label htmlFor="gio-dang" className="mb-1 block text-phu font-medium text-chu-phu">
                Giờ (GMT+7)
              </label>
              <input
                id="gio-dang"
                type="time"
                value={gio}
                onChange={(e) => {
                  setGio(e.target.value);
                }}
                className="vung-bam rounded-[10px] border border-vien px-3 text-co-ban text-chu"
              />
            </div>
          </div>
        </div>
      )}
    </HopThoai>
  );
}
